import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const Logo = ({ className = "", light = false, testId = "header-logo" }) => {
  return (
    <Link
      to="/"
      data-testid={testId}
      className={`group inline-flex items-center gap-2.5 ${className}`}
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-brand shadow-[0_6px_18px_-4px_rgba(232,80,46,0.6)] transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105">
        <Zap className="h-5 w-5 fill-white text-white" strokeWidth={2.5} />
      </span>
      <span className={`font-display text-lg font-bold tracking-tight ${light ? "text-white" : "text-ink"}`}>
        Leadzi{" "}
        <span className="rounded-md bg-brand px-1.5 py-0.5 text-white">CHR</span>
      </span>
    </Link>
  );
};
